// Labels of the Reminder Monitor tabs. Values mirror the REM_* enums in the backend's prisma/schema.prisma.

const TONE = {
  brand: "bg-primary_tint text-primary border-border",
  success: "bg-success_bg text-success border-success_border",
  warning: "bg-warning_bg text-warning border-warning_border",
  danger: "bg-danger_bg text-danger border-danger_border",
  info: "bg-info_bg text-info border-info_border",
  muted: "bg-surface_alt text-text_secondary border-border",
};

// A reminder case (tbl_rem_instance.status).
export const CASE_STATUS = {
  OPEN: { label: "Open", classes: TONE.brand, hint: "Reminders still go out." },
  RESOLVED: { label: "Resolved", classes: TONE.success, hint: "The record no longer matches." },
  EXHAUSTED: { label: "Exhausted", classes: TONE.warning, hint: "Every reminder was sent." },
  STOPPED: { label: "Stopped", classes: TONE.muted, hint: "Stopped by hand, by the rule or the user." },
  SKIPPED: { label: "Skipped", classes: TONE.muted, hint: "Kept for the record; nothing sent." },
};

// One message (tbl_rem_delivery.status).
export const DELIVERY_STATUS = {
  QUEUED: { label: "Queued", classes: TONE.info },
  SENT: { label: "Sent", classes: TONE.success },
  FAILED: { label: "Failed", classes: TONE.danger },
  SKIPPED: { label: "Skipped", classes: TONE.muted },
};

// One evaluation of a rule (tbl_rem_run_log.status / source).
export const RUN_STATUS = {
  SUCCESS: { label: "Success", classes: TONE.success },
  PARTIAL: { label: "Partial", classes: TONE.warning },
  FAILED: { label: "Failed", classes: TONE.danger },
  SKIPPED: { label: "Skipped", classes: TONE.muted },
};

export const RUN_SOURCE_LABEL = { SCHEDULER: "Schedule", DOMAIN_EVENT: "Domain event", MANUAL: "Run now", TEST: "Test run" };

// Why a case closed (resolved_reason; MANUAL may carry ": <reason>").
export const CLOSE_REASON_LABEL = {
  CONDITION_CLEARED: "The record no longer matches",
  MAX_REACHED: "Every reminder was sent",
  LAST_STEP_DONE: "The last step was sent",
  TIME_LIMIT: "The stop-after limit passed",
  RULE_ENDED: "The rule's valid-to date passed",
  RULE_ARCHIVED: "The rule was archived",
  SUBJECT_INACTIVE: "The user was deactivated",
  RECORD_GONE: "The record was deleted",
  ENGINE_ERROR: "Stopped after repeated errors",
  MANUAL: "Stopped by hand",
};

// Why a message was not sent (skip_reason).
export const SKIP_REASON_LABEL = {
  NO_RECIPIENT: "Nobody to send to",
  NO_ADDRESS: "No email address",
  NO_USER: "Not a SwiftBoard user",
  OPTED_OUT: "Switched off in Settings",
  NOT_WORKING_DAY: "Not a working day",
  CHANNEL_NOT_SUPPORTED: "Channel not available yet",
  ENGINE_ERROR: "Engine error",
};

export const CHANNEL_LABEL = { EMAIL: "Email", IN_APP: "In-app", SMS: "SMS", WHATSAPP: "WhatsApp" };

export const toOptions = (map) => Object.entries(map).map(([value, meta]) => ({ value, label: typeof meta === "string" ? meta : meta.label }));
